import { render, staticRenderFns } from "./ArtistIntro.vue?vue&type=template&id=f83085a8"
import script from "./ArtistIntro.vue?vue&type=script&lang=js"
export * from "./ArtistIntro.vue?vue&type=script&lang=js"
import style0 from "./ArtistIntro.vue?vue&type=style&index=0&id=f83085a8&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports